<template>
    <div class="wrapContainer">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "sign"
    }
</script>

<style scoped>
    .wrapContainer{
        width:100%;
        height: 100%;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/views/phoneHome/sign.vue